var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-banner"},[_c('swiper',{ref:"swiperTop",staticClass:"swiper",attrs:{"options":_vm.swiperOptionTop}},_vm._l((_vm.banner),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{staticClass:"banner-img",attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }